import deUnderscore from '../utils/deUnderscore'

export default function posFoodProductFieldMapFactory(taxonomyMap) {
  const mapTaxonomyToValue = (value, field) => {
    try {
      return taxonomyMap[field].filter(item => item.name === value)[0].description
    }
    catch (err) {
      return 'unknown'
    }
  }

  return {
    productCategory: function(store) {
      if (this.hasOwnProperty('posFoodProductCategory') && this.posFoodProductCategory !== '') {
        return mapTaxonomyToValue(this.posFoodProductCategory, 'pos_food_category')
      } else {
        return ''
      }
    }
  }
}
